import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AppConstants } from '../../../../core/common/app-constants';

@Component({
  selector: 'app-contact-comp1',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contactcomp1.component.html',
  styleUrls: ['./contactcomp1.component.scss']
})
export class contactcomp1Component {

  contactoForm: FormGroup;
  enviando = signal(false);
  emailContacto = AppConstants.Contacto.email;

  constructor(private fb: FormBuilder) {
    this.contactoForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.minLength(3)]],
      documento: ['', [Validators.required, Validators.pattern('^[0-9]{8,11}$')]],
      correo: ['', [Validators.required, Validators.email]],
      telefono: ['', [Validators.required, Validators.pattern('^[0-9]{9,12}$')]],
      comentarios: ['', [Validators.required, Validators.maxLength(500)]]
    });
  }

  onSubmit() {
    if (this.contactoForm.valid) {
      this.enviando.set(true);
      console.log('Datos de contacto:', this.contactoForm.value);
      
      // Simulación de envío al backend
      setTimeout(() => {
        alert('Mensaje enviado con éxito. Pronto nos comunicaremos contigo.');
        this.contactoForm.reset();
        this.enviando.set(false);
      }, 2000);
    }
  }
  
  // contactForm: FormGroup;
  // submitted = false;

  // constructor(private fb: FormBuilder) {
  //   this.contactForm = this.fb.group({
  //     name: ['', [Validators.required, Validators.minLength(3)]],
  //     email: ['', [Validators.required, Validators.email]],
  //     message: ['', [Validators.required, Validators.minLength(10)]]
  //   });
  // }

  // get f() {
  //   return this.contactForm.controls;
  // }

  // isInvalid(controlName: string): boolean {
  //   const control = this.contactForm.get(controlName);
  //   return !!(control && control.invalid && (control.dirty || control.touched));
  // }

  // onSubmit(): void {
  //   this.submitted = true;
  //   if (this.contactForm.invalid) {
  //     return;
  //   }
  //   console.log('Formulario válido ✅', this.contactForm.value);
  //   this.contactForm.reset();
  //   this.submitted = false;
  // }

}